import { render, staticRenderFns } from "./IdentitySelect.vue?vue&type=template&id=98b16810&scoped=true"
import script from "./IdentitySelect.vue?vue&type=script&lang=js"
export * from "./IdentitySelect.vue?vue&type=script&lang=js"
import style0 from "./IdentitySelect.vue?vue&type=style&index=0&id=98b16810&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b16810",
  null
  
)

export default component.exports